var path = 'ng-table/filters/number.html';
var html = "<input type=number name={{name}} ng-disabled=$filterRow.disabled ng-model=params.filter()[name] class=\"input-filter form-control\" placeholder=\"{{getFilterPlaceholderValue(filter, name)}}\"/> ";
var angular = require('angular');
angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/browser/filters/number.html
// module id = 25
// module chunks = 0